import React, { useState, useEffect } from "react"
import { SortNewsByPublishedYear } from "../news-helper"

export default function NewsListPageComponent({
  news,
  newsCategories,
  heading,
  subheading,
  readLessButtonText,
  readMoreButtonText,
  searchLabel,
  newsShown,
}) {
  const [uniqueYears, setUniqueYears] = useState([])
  const [selectedYear, setSelectedYear] = useState("")
  const [isReadingMore, setIsReadingMore] = useState(false)
  const [desiredNews, setDesiredNews] = useState(news)

  //news items we render based on desired news resultset.
  const [newsItemsShortListToRender, setNewsItemsShortListToRender] = useState([])
  const [newsItemsAllToRender, setNewsItemsAllToRender] = useState([])
  const OriginalUrl = window.location.href

  //setting news in state & adding a parsed publishDate property pr. news object.
  const [newsSortedByYear, setNewsSortedByYear] = useState(SortNewsByPublishedYear(news))

  useEffect(() => {
    const uniqueYearsSet = new Set()

    news.forEach((newsItem) => {
      if (newsItem.year_s) {
        uniqueYearsSet.add(newsItem.year_s)
      }
    })
    // Convert the set back to an array and update & sort the state
    setUniqueYears(Array.from(uniqueYearsSet).sort((a, b) => b - a))
  }, [news])

  //set selected year to URL fragment if URL fragment matches a 4 digit number, might be relevant to update in year 10000
  useEffect(() => {
    const fourDigitsRegex = /^\d{4}$/
    var url = window.location.href
    let urlArray = url.split("/")
    let urlIsYear = fourDigitsRegex.test(urlArray[urlArray.length - 1])
    if (urlIsYear) {
      setSelectedYear(urlArray[urlArray.length - 1])
    }
  }, [])

  useEffect(() => {
    let filteredNews

    //Showing all news
    if (!selectedYear) {
      setDesiredNews(newsSortedByYear)
      return
    }

    //filtering by selected year
    if (selectedYear) {
      filteredNews = newsSortedByYear.filter((news) => news.year_s === selectedYear)
      //selecting news based on year
      setDesiredNews(filteredNews)
      return
    }
  }, [selectedYear])

  useEffect(() => {
    let newsItems = desiredNews.map((item) => (
      <NewsRow
        key={item.header_s + " " + item.originalPublishDate_s}
        url={item.pageUrl_s}
        heading={item.header_s}
        publishDate={item.originalPublishDate_s.split(" ")[0]}
      />
    ))

    // Use Set to keep track of unique elements
    const uniqueElementsSet = new Set()

    // Filter the JSX elements array to remove duplicates
    const uniqueJsxElements = newsItems.filter((element) => {
      const elementId = element.key
      if (!uniqueElementsSet.has(elementId)) {
        uniqueElementsSet.add(elementId)
        return true
      }
      return false
    })

    setNewsItemsShortListToRender(uniqueJsxElements.slice(0, newsShown))
    setNewsItemsAllToRender(uniqueJsxElements)
  }, [desiredNews, isReadingMore])

  //handling URL change when selecting a year
  const handleSelectYear = (newYear) => {
    const currentUrl = window.location.href
    const urlParts = currentUrl.split("/")
    const lastPart = urlParts[urlParts.length - 1]

    if (!isNaN(parseInt(lastPart))) {
      // If the last part of the URL is a year, replace it with the new year
      urlParts[urlParts.length - 1] = newYear
    } else {
      // If not, append the selected year to the URL
      urlParts.push(newYear)
    }

    // Join URL parts and remove any trailing slashes
    let newPath = urlParts.join("/")
    newPath = newPath.replace(/\/+$/, "") // Remove trailing slashes

    // Ensure there's at least one slash after the base URL
    if (newPath === window.location.origin) {
      newPath += "/"
    }

    window.history.pushState(null, null, newPath)
    setSelectedYear(newYear)
    setIsReadingMore(false)
  }

  return (
    <section className="news-overview-section">
      <div className="w--normal">
        {/**heading area */}
        <h1 data-epi-property-name="Heading" className="overview-heading">
          {heading}
        </h1>
        <p data-epi-property-name="Subheading" className="overview-subtext w--narrow">
          {subheading}
        </p>
        {/**heading area end*/}

        {/**year selector */}
        <div className="news-year-selector">
          {/**year selector end*/}
          <div className="yearselect-container">
            <div className="firefox-fix">
              <label htmlFor="year">{"selectYearButtonText"}</label>
              <select id="year" onChange={(e) => handleSelectYear(e.target.value)} value={selectedYear}>
                <option data-epi-property-name="SearchLabel" value="">
                  {searchLabel}
                </option>
                {uniqueYears.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>
          </div>
          {/**news generation*/}
          <div className="news-content">{isReadingMore ? newsItemsAllToRender : newsItemsShortListToRender}</div>
          {/* *news generation end */}
          <div className="readmore-button-container">
            {desiredNews.length > newsShown ? (
              <button className={isReadingMore ? "readless" : "readmore"} onClick={() => setIsReadingMore(!isReadingMore)}>
                {isReadingMore ? readLessButtonText || "Læs mindre" : readMoreButtonText || "Læs mere"}
              </button>
            ) : undefined}
          </div>
        </div>
      </div>
    </section>
  )
}

const NewsRow = ({ url, heading, publishDate }) => {
  return (
    <div className="row-element">
      <a href={url} target="_blank" rel="noopener noreferrer" className="news-row">
        <p className="news-row-date">{publishDate.replaceAll("/", ".").replaceAll("-", ".")}</p>
        <h2 className="news-row-heading">{heading}</h2>
        <div className="infoarrow"></div>
      </a>
    </div>
  )
}
